import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Trip2ThemeModule} from '../../trip2-theme/trip2-theme.module';
import {DriverBackgroundCheckComponent} from './driver-background-check.component';
import {MaskPIIPipe} from './mask-pii.pipe';
import {BgcFieldRowComponent} from './components/bgc-field-row/bgc-field-row.component';
import {BgcToolbarComponent} from './components/bgc-toolbar/bgc-toolbar.component';
import {BgcStatusBarComponent} from './components/bgc-status-bar/bgc-status-bar.component';
import {BgcStatusBannerComponent} from './components/bgc-status-banner/bgc-status-banner.component';
import {BgcSidebarComponent} from './components/bgc-sidebar/bgc-sidebar.component';
import {BgcDeactivateModalComponent} from './components/bgc-deactivate-modal/bgc-deactivate-modal.component';
import {BgcSectionPermitsComponent} from './components/bgc-section-permits/bgc-section-permits.component';
import {BgcSectionCriminalComponent} from './components/bgc-section-criminal/bgc-section-criminal.component';
import {BgcSectionWatchlistComponent} from './components/bgc-section-watchlist/bgc-section-watchlist.component';
import {BgcSectionSummaryComponent} from './components/bgc-section-summary/bgc-section-summary.component';
import {BgcSectionIdentityComponent} from './components/bgc-section-identity/bgc-section-identity.component';
import {BgcSectionLicensesComponent} from './components/bgc-section-licenses/bgc-section-licenses.component';
import {BgcSectionMvrComponent} from './components/bgc-section-mvr/bgc-section-mvr.component';
import {BgcSectionDocumentsComponent} from './components/bgc-section-documents/bgc-section-documents.component';
import {BgcSectionDetailsComponent} from './components/bgc-section-details/bgc-section-details.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    Trip2ThemeModule
  ],
  declarations: [
    DriverBackgroundCheckComponent,
    MaskPIIPipe,
    BgcFieldRowComponent,
    BgcToolbarComponent,
    BgcStatusBarComponent,
    BgcStatusBannerComponent,
    BgcSidebarComponent,
    BgcDeactivateModalComponent,
    BgcSectionPermitsComponent,
    BgcSectionCriminalComponent,
    BgcSectionWatchlistComponent,
    BgcSectionSummaryComponent,
    BgcSectionIdentityComponent,
    BgcSectionLicensesComponent,
    BgcSectionMvrComponent,
    BgcSectionDocumentsComponent,
    BgcSectionDetailsComponent
  ],
  exports: [
    DriverBackgroundCheckComponent
  ]
})
export class DriverBackgroundCheckModule {
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/driver-background-check.module.ts